import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function eventReducer(state = initialState.events, action) {
  let newState;

  switch (action.type) {
    case types.LOAD_EVENTS:
      newState = objectAssign({}, state, {loadingEvents: true});
      newState.eventList = initialState.events.eventList;
      newState.eventListUpdated = Date.now();
      return newState;

    case types.LOAD_EVENTS_SUCCESS:
      newState = objectAssign({}, state, {loadingEvents: false});
      newState.eventList = action.eventList;
      newState.eventListUpdated = action.eventListUpdated;
      return newState;

    case types.LOAD_EVENT_DETAILS:
      newState = objectAssign({}, state, {loadingEvents: true});
      newState.eventDetails = initialState.events.eventDetails;
      newState.eventDetailsUpdated = Date.now();
      return newState;

    case types.LOAD_EVENT_DETAILS_SUCCESS:
      newState = objectAssign({}, state, {loadingEvents: false});
      newState.eventDetails = action.eventDetails;
      newState.eventDetailsUpdated = action.eventDetailsUpdated;
      return newState;

    case types.LOAD_EVENT_DETAILS_FAILURE:
      newState = objectAssign({}, state, {loadingEvents: false});
      newState.errors = action.errors;
      return newState;

    case types.LOAD_EVENT_TEAM_SETTINGS:
      newState = objectAssign({}, state, {loadingEvents: true});
      return newState;

    case types.LOAD_EVENT_TEAM_SETTINGS_SUCCESS:
      newState = objectAssign({}, state, {loadingEvents: false});
      newState.teamList = action.teamList;
      newState.teamListUpdated = action.teamListUpdated;
      return newState;

    case types.LOAD_EVENT_TEAM_SETTINGS_FAILURE:
      newState = objectAssign({}, state, {loadingEvents: false});
      newState.errors = action.errors;
      return newState;

    case types.UPDATE_EVENT_TEAM_SETTINGS_FAILURE:
      newState = objectAssign({}, state, {loadingEvents: false});
      newState.teamErrors = action.errors;
      return newState;

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/eventReducer.js
 **/